module.exports = __webpack_public_path__ + "static/img/logo.be364a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baoming2/logo.png
// module id = Hjf/
// module chunks = 1